var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgwhiteperson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_42_30)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.0444,
    y: 13.5439,
    width: 80,
    height: 80,
    rx: 15,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0491 34.7731C68.1919 35.4605 69.1374 36.4318 69.7937 37.5927C70.45 38.7536 70.7947 40.0645 70.7945 41.3981C70.7947 42.7317 70.45 44.0426 69.7937 45.2035C69.1374 46.3644 68.1919 47.3358 67.0491 48.0231M79.6278 73.4189V72.0939C79.6278 67.1473 79.6278 64.6739 78.665 62.7836C77.8181 61.1216 76.4668 59.7703 74.8048 58.9234M52.0236 49.1273C53.0386 49.1273 54.0437 48.9274 54.9814 48.5389C55.9192 48.1505 56.7712 47.5812 57.489 46.8635C58.2067 46.1457 58.776 45.2937 59.1644 44.3559C59.5529 43.4182 59.7528 42.4131 59.7528 41.3981C59.7528 40.3831 59.5529 39.378 59.1644 38.4403C58.776 37.5025 58.2067 36.6505 57.489 35.9328C56.7712 35.215 55.9192 34.6457 54.9814 34.2573C54.0437 33.8689 53.0386 33.6689 52.0236 33.6689C49.9737 33.6689 48.0078 34.4833 46.5583 35.9328C45.1088 37.3823 44.2945 39.3482 44.2945 41.3981C44.2945 43.448 45.1088 45.414 46.5583 46.8635C48.0078 48.313 49.9737 49.1273 52.0236 49.1273ZM35.4611 72.0939V73.4189H68.5861V72.0939C68.5861 67.1473 68.5861 64.6739 67.6233 62.7836C66.7764 61.1216 65.4251 59.7703 63.7631 58.9234C61.8728 57.9606 59.3995 57.9606 54.4528 57.9606H49.5945C44.6478 57.9606 42.1745 57.9606 40.2841 58.9234C38.6221 59.7703 37.2708 61.1216 36.424 62.7836C35.4611 64.6739 35.4611 67.1473 35.4611 72.0939Z",
    stroke: "#2B57FB",
    strokeWidth: 1.93422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_42_30",
    x: 0.823599,
    y: 0.915333,
    width: 114.442,
    height: 114.442,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.59222
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.61042
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.847059 0 0 0 0 0.823529 0 0 0 0 0.988235 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_42_30"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_42_30",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgwhiteperson);
export default __webpack_public_path__ + "static/media/bgwhiteperson.0ba4018f57724326281d09944bfaf14c.svg";
export { ForwardRef as ReactComponent };